import { FC } from 'react';

import { Link2 } from 'lucide-react';

import CircularProgress from '@mui/material/CircularProgress';

import css from './InvitedBy.module.css';

import { ProfileCard } from 'v2/components/profileCard/ProfileCard';
import { UserLink } from 'v2/components/userLink/UserLink';
import { LONG_DASH } from 'v2/constants';
import { UserModel } from 'v2/types/UserModel';

interface InvitedByProps {
  inviter?: UserModel;
  hasInviter: boolean;
}

export const InvitedBy: FC<InvitedByProps> = ({ inviter, hasInviter }) => (
  <ProfileCard title="Invited By" icon={<Link2 width={18} height={18} />}>
    {!hasInviter && <p className={css.placeholder}>{LONG_DASH}</p>}

    {hasInviter && inviter == null && (
      <div className={css.loading}>
        <CircularProgress size={22} />
      </div>
    )}

    {hasInviter && inviter != null && (
      <UserLink userId={inviter.id} nickname={inviter.userNickname} imgUrl={inviter.imgUrl} />
    )}
  </ProfileCard>
);
